import { z } from 'zod';

export const SUPPORTED_RAG_MIME_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
] as const;

export const supportedRagMimeSchema = z.enum(SUPPORTED_RAG_MIME_TYPES);

export type SupportedRagMime = z.infer<typeof supportedRagMimeSchema>;
